const FEMALE_NAME =
  /female|\baria\b|\bjenny\b|\bzira\b|\bsamantha\b|\bvictoria\b|\bkaren\b|\bmoira\b|\bfiona\b|\btessa\b|\bsonia\b|\blibby\b|\bnatasha\b|\ballison\b|\bava\b|\bemma\b|\bmichelle\b|\blinda\b|\bheather\b|\bsusan\b|\bhazel\b|\bcatherine\b|\bserena\b|\bjoanna\b|\bkendra\b|\bsalli\b|\bnicole\b|\bolivia\b|\bamy\b/i;
const MALE_NAME =
  /\bmale\b|\bdavid\b|\bmark\b|\bguy\b|\beric\b|\bjames\b|\bbrian\b|\bmatthew\b|\bjustin\b|\bjoey\b|\brishi\b|\bdaniel\b|\bgeraint\b/i;
const NATURAL_NAME = /natural|neural|premium|enhanced/i;

function speechVoiceScore(voice) {
  const name = String((voice && voice.name) || '');
  const lang = String((voice && voice.lang) || '').toLowerCase();
  if (!lang.startsWith('en')) return -1;
  const female = FEMALE_NAME.test(name);
  const male = MALE_NAME.test(name);
  if (male && !female) return -1;
  if (!female) return -1;
  let score = 10;
  if (NATURAL_NAME.test(name)) score += 40;
  if (/google uk english female/i.test(name)) score += 6;
  if (lang === 'en-us') score += 3;
  else if (lang.startsWith('en-gb')) score += 2;
  else score += 1;
  return score;
}

function pickFemaleSpeechVoice(voices) {
  let best = null;
  let bestScore = 0;
  for (const voice of voices || []) {
    const score = speechVoiceScore(voice);
    if (score > bestScore) {
      best = voice;
      bestScore = score;
    }
  }
  return best;
}

function speechVoicesFrom(synth, timeoutMs = 500) {
  if (!synth || typeof synth.getVoices !== 'function') {
    return Promise.resolve([]);
  }
  const ready = synth.getVoices();
  if (ready && ready.length) return Promise.resolve(ready);
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      if (typeof synth.removeEventListener === 'function') {
        synth.removeEventListener('voiceschanged', finish);
      }
      const voices = synth.getVoices();
      resolve(voices && voices.length ? voices : []);
    };
    if (typeof synth.addEventListener === 'function') {
      synth.addEventListener('voiceschanged', finish);
    }
    setTimeout(finish, timeoutMs);
  });
}

module.exports = {
  pickFemaleSpeechVoice,
  speechVoicesFrom,
};
